import { axios } from '../config/axios';

const endPoint = '/project/raw-score';

const generateRawScore = (projectMasterId) => {
    return axios.get(`${endPoint}/generate-raw-score/${projectMasterId}`);
}

const downloadRawScore = (projectMasterId) => {
    return axios.get(`${endPoint}/download-raw-score/${projectMasterId}`, {
        responseType: 'blob',
    });
}

const downloadTenXReport = (projectMasterId) => {
    return axios.get(`${endPoint}/download-ten-x-report/${projectMasterId}`, {
        responseType: 'blob',
    });
}


export {
    generateRawScore,
    downloadRawScore,
    downloadTenXReport,
}